import { PropsWithChildren, FC } from 'react'
import { List } from 'antd'

import { ExceptionDisplay } from './components/ExceptionDisplay'
import { ExceptionDrawerBodyType } from './types'
import styles from './styles.css'
const ExceptionsDrawerBody: FC<PropsWithChildren<ExceptionDrawerBodyType>> = ({
    exceptionFailuresData,
    header,
}) => {
    return !exceptionFailuresData ||
        exceptionFailuresData?.length === 0 ? null : (
        <List
            header={header}
            className={styles.listWrapper}
            itemLayout="vertical"
            dataSource={exceptionFailuresData}
            renderItem={item => {
                return (
                    <List.Item className={styles.listItem}>
                        <ExceptionDisplay item={item} />
                    </List.Item>
                )
            }}
        />
    )
}

export default ExceptionsDrawerBody
